// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__E3gNS","content":"Consent_content__2k9gQ","footer":"Consent_footer__37Qxc"};